//-- Copyright (c) 2021 TMT Insights Group, LLC
import type { MenuItemProps } from '@mui/material';
import { MenuItem, Tooltip } from '@mui/material';
import { ReactNode } from 'react';
import styled from '@emotion/styled';

type OverflowMenuItemProps = MenuItemProps & {
  children: ReactNode;
  disabledTooltipText?: string;
};

const OverflowMenuItem = ({ children, disabledTooltipText, ...props }: OverflowMenuItemProps) => {
  const content = <StyledMenuItem {...props}>{children}</StyledMenuItem>;

  return props.disabled ? (
    <Tooltip title={disabledTooltipText} placement="left">
      <span>{content}</span>
    </Tooltip>
  ) : (
    content
  );
};

export default OverflowMenuItem;

const StyledMenuItem = styled(MenuItem)`
  padding: ${({ theme }) => theme.spacing(1, 1.5)};

  & svg {
    opacity: 0.7;
    margin-right: ${({ theme }) => theme.spacing(1.25)};
    min-width: ${({ theme }) => theme.spacing(3)};
    color: ${({ theme }) => theme.palette.text.primary};
  }
`;
